export default {
  title: 'Configuração de farol',
  description: 'Defina o valor para as respectivas cores e níveis de criticidade. O valor é considerado em minutos.',
  critic: 'Crítico',
  warning: 'Atenção'
}
